import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { VNQRCode } from 'vn-react-components/VNComponents/VNQRCode'
import { generateURL } from '../../utils/richCheckout'
import { getCartTotals, getFormattedCartItems, getInitializedValues } from '../Selectors'
import { RICH_CHECKOUT_TEXT_PROMPT } from '../../constants'
import { isEmpty } from '../../VNUtil/VNUtils'
import styles from './VNPayWithApp.module.scss'

export const VNPayWithApp = (props) => {
  // SELECTORS

  const cartTotals = useSelector((state) => getCartTotals(state))
  const cartItems = useSelector((state) => getFormattedCartItems(state))
  const initialValues = useSelector((state) => getInitializedValues(state))

  // LOCAL STATE

  const [qrCodeData, setQRCodeData] = useState(null)

  // USE EFFECTS

  useEffect(() => {
    if (!initialValues?.has('deviceId') || !cartTotals.has('uuid') || isEmpty(cartItems)) {
      return
    }

    setQRCodeData(
      generateURL(
        cartTotals?.get('uuid'),
        cartTotals?.get('orderNumber'),
        `${initialValues.get('appConfigurationDeviceId')}`,
        cartTotals?.get('total'),
        cartItems,
      ),
    )
  }, [cartItems, initialValues, cartTotals])

  const displayQRCode = () => {
    if (qrCodeData) {
      return (
        <div className={styles.qrcode}>
          <VNQRCode text={qrCodeData} />
        </div>
      )
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {displayQRCode()}
        <div className={styles.description}>
          <div className={styles.title}>Pay with App</div>
          <div className={styles.subtitle}>{RICH_CHECKOUT_TEXT_PROMPT}</div>
        </div>
      </div>
    </div>
  )
}
